import { createReducer } from '@reduxjs/toolkit';

import { BuilderTabType } from '~/enums/BuilderTabType';
import { isLatestVersion } from '~/utils/workflow';

import {
  builderReset,
  builderSetFieldSections,
  builderSetInitialWorkflow,
  builderSetShouldEditParties,
  builderSetShouldEditSetup,
  builderSetShouldEnableAllComponents,
  builderSetShouldValidate,
  builderSetTab,
} from '../actions/builder';

export const getInitialState = () => ({
  selectedTab: BuilderTabType.Source,
  shouldValidate: false,
  shouldEditSetup: false,
  shouldEditParties: false,
  shouldEnableAllComponents: true,
  initialWorkflow: {},
  fieldSections: {},
});

export default createReducer(getInitialState(), (builder) => {
  builder.addCase(builderReset, getInitialState);
  builder.addCase(builderSetShouldEditSetup, (state, action) => {
    state.shouldEditSetup = action.payload;
  });
  builder.addCase(builderSetShouldEditParties, (state, action) => {
    state.shouldEditParties = action.payload;
  });
  builder.addCase(builderSetShouldValidate, (state) => {
    state.shouldValidate = true;
  });
  builder.addCase(builderSetTab, (state, action) => {
    state.selectedTab = action.payload;
  });
  builder.addCase(builderSetInitialWorkflow, (state, action) => {
    state.initialWorkflow = action.payload;
  });
  builder.addCase(builderSetFieldSections, (state, action) => {
    state.fieldSections = action.payload;
  });
  builder.addCase(builderSetShouldEnableAllComponents, (state, action) => {
    state.shouldEnableAllComponents =
      isLatestVersion(action.payload) || action.payload.isDraft;
  });
});
